import React from 'react';
import { Col, Row,Card } from 'antd';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import "react-simple-keyboard/build/css/index.css";

const MainBlock = styled.div`
  padding: 10px;
  background: #d9e2f1;
  margin-top: 10px;
`;

const ListPage = (props) => {
  return (
    <>
      <Col span={24} style={{textAlign: "left", margin:0}} className="list-col">
        <MainBlock className="list-mailblock">
        <Row gutter={[24, 16]} style={{height:"100%"}} className="list-col-box-row">
          <Col span={8} className="list-col-box">
            <Link to={`/tool/word/all`} className="list-col-box-a">
              <Card bordered={false} className="list-col-box-a-card">
                VOCA
              </Card>
            </Link>
          </Col>
          <Col span={8} className="list-col-box">
            <Link to={`/tool/quiz/all`} className="list-col-box-a">
              <Card bordered={false} className="list-col-box-a-card">
                QUIZ
              </Card>
            </Link>
          </Col>
          <Col span={8} className="list-col-box">
            <Link to={`/tool/listen/all`} className="list-col-box-a">
              <Card bordered={false} className="list-col-box-a-card">
                LISTEN
              </Card>
            </Link>
          </Col>
          <Col span={8} className="list-col-box">
            <Link to={`/tool/listen-repeat/all`} className="list-col-box-a">
              <Card bordered={false} className="list-col-box-a-card">
                LISTEN Repeat
              </Card>
            </Link>
          </Col>
          <Col span={8} className="list-col-box">
            <Link to={`/tool/listen-stt/all`} className="list-col-box-a">
              <Card bordered={false} className="list-col-box-a-card">
                LISTEN STT
              </Card>
            </Link>
          </Col>
          <Col span={8} className="list-col-box">
            <Link to={`/tool/translate/all`} className="list-col-box-a">
              <Card bordered={false} className="list-col-box-a-card">
                TRANSALATE
              </Card>
            </Link>
          </Col>
          <Col span={8} className="list-col-box">
            <Link to={`/tool/translate-word/all`} className="list-col-box-a">
              <Card bordered={false} className="list-col-box-a-card">
                TRANSALATE WORD
              </Card>
            </Link>
          </Col>
          <Col span={8} className="list-col-box">
            <Link to={`/tool/essay/all`} className="list-col-box-a">
              <Card bordered={false} className="list-col-box-a-card">
                ESSAY
              </Card>
            </Link>
          </Col>
        </Row>
        </MainBlock>
      </Col>
      
    </>
  );
};

export default ListPage;
